var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 3.33333H12.6667C13.0349 3.33333 13.3333 3.63181 13.3333 4V9.33333C13.3333 9.70152 13.0349 10 12.6667 10H7.33333C6.96514 10 6.66667 9.70152 6.66667 9.33333V4C6.66667 3.63181 6.96514 3.33333 7.33333 3.33333ZM5.33333 4C5.33333 2.89543 6.22876 2 7.33333 2H12.6667C13.7712 2 14.6667 2.89543 14.6667 4V9.33333C14.6667 10.4379 13.7712 11.3333 12.6667 11.3333H7.33333C6.22876 11.3333 5.33333 10.4379 5.33333 9.33333V4ZM4 4.66667H4.66667V6H4C3.63181 6 3.33333 6.29848 3.33333 6.66667V12C3.33333 12.3682 3.63181 12.6667 4 12.6667H9.33333C9.70152 12.6667 10 12.3682 10 12H11.3333C11.3333 13.1046 10.4379 14 9.33333 14H4C2.89543 14 2 13.1046 2 12V6.66667C2 5.5621 2.89543 4.66667 4 4.66667Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.759ab6d6.svg";
export { ForwardRef as ReactComponent };